<ul [ngClass]="activeLanguage$ | async">
  <li (click)="clickDownloadCategory('All', 'All')" [ngClass]="{ active: activeCategory === 'All' }">
    {{ 'newsArticles.all' | cxTranslate }}
  </li>
  <li *ngFor="let data of sortData('typeName')" [ngClass]="{ active: activeCategory === data.typeCode }">
    <span (click)="clickDownloadCategory(data.typeCode, data.typeName)">{{ data.typeName }}</span>
  </li>
</ul>
<div class="btn-group" id="searchDownloadCategoryDropdown">
  <div mat-button [matMenuTriggerFor]="categoryMenu">
    <span class="label-wrapper">
      {{ activeCategoryTypeName !== 'All' ? activeCategoryTypeName : ('newsArticles.all' | cxTranslate) }}
      <mat-icon class="expand-icon">expand_more</mat-icon>
    </span>
  </div>
  <mat-menu #categoryMenu="matMenu" class="custom-menu">
    <div
      mat-menu-item
      (click)="clickDownloadCategory('All', 'All')"
      [ngClass]="{ 'selected-item': activeCategory === 'All' }"
    >
      <mat-icon svgIcon="check" *ngIf="activeCategory === 'All'" class="check-icon"></mat-icon>
      <span class="category-label">{{ 'newsArticles.all' | cxTranslate }}</span>
    </div>

    <div
      mat-menu-item
      *ngFor="let data of sortData('typeName')"
      (click)="clickDownloadCategory(data.typeCode, data.typeName)"
      [ngClass]="{ 'selected-item': activeCategory === data.typeCode }"
    >
      <mat-icon svgIcon="check" *ngIf="activeCategory === data.typeCode" class="check-icon"></mat-icon>
      <span class="category-label">{{ data.typeName }}</span>
    </div>
  </mat-menu>
</div>
